/* eslint-disable react/jsx-curly-newline */
import { useRef, useState, useEffect, ReactNode } from 'react';
import { MdOutlineFileUpload } from 'react-icons/md';
import { FaTrashAlt } from 'react-icons/fa';
import { ReactComponent as ErrorFile } from 'assets/images/upload/errorFile.svg';
import { ReactComponent as ErrorSize } from 'assets/images/upload/errorSize.svg';
import { Button } from '@grupoboticario/flora-react';

import environment from 'environments/environment';

import {
  UploadInputWrapper,
  UploadedList,
  UploadedListFile,
  Loading,
} from './styles';

export interface FilesCallback {
  idDoc: string;
  file: any;
}
interface IUpload {
  idDoc: string;
  setState?: any;
  required: boolean;
  dropFiles?: any;
  // typeFiles?: 'image' | 'video' | 'all';
  deleteFile: any;

  callbackFunc: (files: any) => void;
  acceptedFiles?: string[];
  hasLoadingFiles?: boolean;
}

interface MountedFiles {
  idFile?: string;
  data: any;
  index?: string;
  status: string;
  error?: string;
  iconError?: ReactNode;
  icon?: ReactNode;
}

const UploadDocument = ({
  idDoc,
  setState = () => {},
  required,
  dropFiles = [],
  deleteFile,

  callbackFunc,
  hasLoadingFiles = true,
  acceptedFiles = [],
}: IUpload): JSX.Element => {
  const [uploadedFiles, setUploadedFiles] = useState<MountedFiles[]>([]);

  const fileSizeLimit = Number(environment.fileSizeLimit);

  const fileInputRef = useRef<HTMLInputElement>(null);

  const fileInputClicked = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const onClickDeleteFile = (file: any) => {
    if (!hasLoadingFiles) {
      const newUploadedFiles = uploadedFiles.filter(o => o.data !== file.data);
      setUploadedFiles(newUploadedFiles);
      deleteFile(file);
    }
  };

  const verifyFileType = (file: File) => {
    console.log(file.type);
    if (file.size > fileSizeLimit * 10) {
      return 'Tamanho maior que o limite';
    }
    if (
      acceptedFiles.length &&
      !acceptedFiles.find((accepted: string) => file.type === accepted)
    ) {
      return 'Arquivo não permitido';
    }

    return '';
  };

  const handleFiles = async (newFiles: FileList) => {
    let newUploadedFiles: MountedFiles[] = [...uploadedFiles];

    for (const element of newFiles) {
      const file = element;

      const fileVerification = verifyFileType(file);

      if (fileVerification) {
        newUploadedFiles = [
          ...newUploadedFiles,
          {
            data: file,
            index: file.name + Date.now(),
            status: 'error',
            error: fileVerification,
            iconError:
              fileVerification === 'Arquivo não permitido' ? (
                <ErrorFile />
              ) : (
                <ErrorSize />
              ),
            icon: <FaTrashAlt className="notUploaded" />,
          },
        ];
      } else if (hasLoadingFiles) {
        newUploadedFiles = [
          ...newUploadedFiles,
          {
            data: file,
            index: file.name + Date.now(),
            status: 'loading',
            error: '',
            iconError: null,
            icon: <Loading />,
          },
        ];
      } else {
        newUploadedFiles = [
          ...newUploadedFiles,
          {
            data: file,
            status: 'dontUploaded',
            icon: <FaTrashAlt className="uploaded" />,
          },
        ];
      }
    }
    setUploadedFiles(newUploadedFiles);
    const newLoadingFiles = newUploadedFiles.filter((file: any) =>
      ['loading', 'dontUploaded'].includes(file.status),
    );
    // se existem arquivos validos entre os recebidos:
    if (newLoadingFiles.length > 0) {
      callbackFunc(
        newLoadingFiles.map(file => ({
          idDoc,
          file,
        })),
      );
    } else {
      callbackFunc([]);
    }
  };

  const onChangeFile = () => {
    if (fileInputRef.current?.files) {
      handleFiles(fileInputRef.current.files);
    }
  };

  useEffect(() => {
    if (dropFiles?.length > 0) {
      handleFiles(dropFiles);
    }
  }, [dropFiles]);

  useEffect(() => {
    if (required && uploadedFiles.length > 0) {
      if (uploadedFiles.find((file: any) => file.status === 'uploaded')) {
        setState((prevState: any) => {
          const newState = { ...prevState };
          newState[idDoc] = true;
          return newState;
        });
      } else {
        setState((prevState: any) => {
          const newState = { ...prevState };
          newState[idDoc] = false;
          return newState;
        });
      }
    } else if (required && uploadedFiles.length === 0) {
      setState((prevState: any) => {
        const newState = { ...prevState };
        newState[idDoc] = false;
        return newState;
      });
    }
  }, [uploadedFiles]);

  return (
    <UploadInputWrapper>
      <form>
        {uploadedFiles.length === 0 && (
          <>
            <MdOutlineFileUpload className="upload" />
            <span>Arraste e solte os arquivos aqui ou se preferir...</span>
          </>
        )}
        {uploadedFiles.length > 0 && (
          <UploadedList>
            {uploadedFiles.map(file => (
              <UploadedListFile status={file.status} key={file?.index}>
                <div className="name">{file?.data?.name}</div>
                {file.iconError && (
                  <div className="iconError">
                    {file.iconError}
                    <div className="hover">ERRO: {file.error}</div>
                  </div>
                )}
                <div
                  className="icon"
                  onClick={() => onClickDeleteFile(file)}
                  onKeyDown={() => onClickDeleteFile(file)}
                  role="button"
                  tabIndex={0}
                >
                  {file.icon}
                </div>
              </UploadedListFile>
            ))}
          </UploadedList>
        )}

        <Button size="small" type="button" onClick={fileInputClicked}>
          Adicione arquivos
        </Button>
        <input
          ref={fileInputRef}
          id={idDoc}
          type="file"
          multiple
          onChange={onChangeFile}
        />
      </form>
    </UploadInputWrapper>
  );
};

export default UploadDocument;
